import {Component, Input, OnInit} from '@angular/core';
import {SharedService} from '@ems/shared';

@Component({
  selector: 'addlink-expanded-row',
  templateUrl: './expanded-row.component.html',
  styleUrls: ['./expanded-row.component.scss'],
})
export class ExpandedRowComponent implements OnInit {

  @Input() request: any;
  @Input() expandedRowColumns: any[] = [];
  @Input() isHidden: boolean;
  @Input() businessRbs: string;
  userPolicy: any;
  accessForRbsClientOnly = false;
  accessToSPSClientOnly = false;

  public filteredRequest: any[];

  constructor(public sharedService: SharedService,) { }

  ngOnInit() {
    this.filterRequest();
  }

  filterRequest(): void {
    this.userPolicy = this.sharedService.getPolicyResponse('success');
     /* eslint-disable-next-line max-len */
     this.accessForRbsClientOnly = (this.userPolicy.data.userPolicy.buPolicy && this.userPolicy.data.userPolicy.buPolicy.length === 1 && this.userPolicy.data.userPolicy.buPolicy.map(x => x.businessUnit).indexOf('RBS') !== -1) || (this.userPolicy.data.userPolicy.buPolicy === null && this.userPolicy.data.clients && this.userPolicy.data.clients.every(x => x.businessUnit === 'RBS'));
     /* eslint-disable-next-line max-len */
     this.accessToSPSClientOnly = (this.userPolicy.data.userPolicy.buPolicy && this.userPolicy.data.userPolicy.buPolicy.length === 1 && this.userPolicy.data.userPolicy.buPolicy.map(x => x.businessUnit).indexOf('SPS') !== -1) || (this.userPolicy.data.userPolicy.buPolicy === null && this.userPolicy.data.clients && this.userPolicy.data.clients.every(x => x.businessUnit === 'SPS'));
   this.filteredRequest = [];
    for (const expandedRowColumn of this.expandedRowColumns) {
      /* If source is comming from client central only display */
      if (expandedRowColumn.field === 'acctHolderName') {

        const acctOwnerFirstName = this.request.accountOwnerFirstName !== '' ? ', ' + this.request.accountOwnerFirstName : '';

        let fieldVal = this.request.accountOwnerLastName + acctOwnerFirstName;
        if (this.request.source !== null && this.request.source === 'Client Central') {
          fieldVal = this.request.accountOwnerLastName;
        }
        this.filteredRequest.push({
          field: fieldVal,
          header: expandedRowColumn.header,
        });
      } else if (expandedRowColumn.field === 'authAgentName' && this.businessRbs === 'DBS' || (expandedRowColumn.field === 'authAgentName' && this.businessRbs === '' && !this.accessToSPSClientOnly && !this.accessForRbsClientOnly)) {
        if (this.request.authAgent && this.request.authAgent !== null) {
          this.filteredRequest.push({
            field: this.request.authAgent.authAgentLastName + ', ' + this.request.authAgent.authAgentFirstName,
            header: expandedRowColumn.header,
          });
        } else {
          this.filteredRequest.push({
            field: '',
            header: expandedRowColumn.header,
          });
        }
      } else if (expandedRowColumn.field === 'assignedTo') {

        let assignedToLastName = this.request.assignedToLastName;
        let assignedToFirstName = this.request.assignedToFirstName;

        if (assignedToLastName === null || assignedToLastName === 'null') {
          assignedToLastName = '';
        }
        if (assignedToFirstName === null || assignedToFirstName === 'null') {
          assignedToFirstName = '';
        } else {
          assignedToFirstName = ', ' + assignedToFirstName;
        }

        this.filteredRequest.push({
          field: assignedToLastName + assignedToFirstName,
          header: expandedRowColumn.header,
        });
      } else if (expandedRowColumn.field === 'accountHolderAffiliation' && (this.businessRbs === 'DBS' || this.businessRbs === 'SPS')) {
        let affiliation = this.request.accountHolderAffiliation;
        if (affiliation === null || affiliation === 'null') {
          affiliation = '';
        }
        this.filteredRequest.push({
          field: affiliation,
          header: expandedRowColumn.header,
        });
      } else if (expandedRowColumn.field === 'completedBy') {
        let completedBy = this.request.completedBy;
        if (completedBy === null || completedBy === 'null') {
          completedBy = '';
        }
        this.filteredRequest.push({
          field: completedBy,
          header: expandedRowColumn.header,
        });
      } else if (expandedRowColumn.field === 'completedDate') {
        let completedDate = this.request.completedDate;
        if (completedDate === null || completedDate === 'null') {
          completedDate = '';
        }
        this.filteredRequest.push({
          field: completedDate,
          header: expandedRowColumn.header,
        });
      } else if ((expandedRowColumn.field === 'authAgentName' || expandedRowColumn.field === 'indexKey' || expandedRowColumn.field === 'liable407') && (this.businessRbs === 'SPS' || this.businessRbs === 'RBS' || this.accessForRbsClientOnly || this.accessToSPSClientOnly)) {
        this.filteredRequest.push(expandedRowColumn);
        const index = this.filteredRequest.findIndex(x => x.field === 'authAgentName' || x.field === 'indexKey' || x.field === 'liable407');
        this.filteredRequest.splice(index, 1);
      } else if ((expandedRowColumn.field === 'accountHolderAffiliation' || expandedRowColumn.field === 'commissionCode') && (this.businessRbs === 'RBS' || this.accessForRbsClientOnly)) {
        this.filteredRequest.push(expandedRowColumn);
        const index = this.filteredRequest.findIndex(x => x.field === 'accountHolderAffiliation' || x.field === 'commissionCode');
        this.filteredRequest.splice(index, 1);
      } else {
        this.filteredRequest.push({
          field: this.request[expandedRowColumn.field],
          header: expandedRowColumn.header
        });
      }
    }
  }
}

